import { injectIntl } from 'react-intl';
import StationSelection from './StationSelection';

export default injectIntl(StationSelection);
